/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useRef } from 'react';

import { func, string } from 'prop-types';

import { PythonIcon, SQLIcon, TriggerIcon, AddonsIcon } from 'Assets/icons';

import './select.scss';

const Icons = {
  sql: <SQLIcon className="p-1" />,
  python: <PythonIcon className="p-1" />,
  addon: <AddonsIcon className="p-1" />,
  yml: <AddonsIcon className="p-1" />,
  yaml: <AddonsIcon className="p-1" />,
  trigger: <TriggerIcon className="p-1" />,
  pipeline: <TriggerIcon className="p-1" />,
  scheduler: <TriggerIcon className="p-1" />,
  cron: <TriggerIcon className="p-1" />
};

/**
 * @typedef {Object} SelectorOptionsProps
 * @property {string} label
 * @property {string | number} value
 *
 * @typedef {Object} SelectorProps
 * @property { string[] | SelectorOptionsProps[] } options
 * @property {string|number} selectedOption
 * @property {function} onSelect
 *
 * @param {SelectorProps} props
 * @returns JSX.Element
 */
export default function Select({ options, selectedOption, onSelect }) {
  const [isContextOpen, setIsContextOpen] = useState(false);
  const contextWrapperRef = useRef(null);
  const verfiyType = (arg, type = 'string') => {
    if (!arg) {
      return undefined;
    }

    return arg === type;
  };

  useEffect(() => {
    function handleClickOutside(e) {
      if (
        contextWrapperRef.current &&
        !contextWrapperRef.current.contains(e.target)
      ) {
        setIsContextOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [contextWrapperRef]);

  function handleToogleSelector() {
    setIsContextOpen((prev) => !prev);
  }

  function handleSelectItem(option) {
    onSelect(option);
    handleToogleSelector();
  }

  return (
    <div
      data-testid="select-component"
      className="select"
      ref={contextWrapperRef}
    >
      <button
        type="button"
        className="select-btn"
        onClick={handleToogleSelector}
      >
        <span className="select-btn_img">
          {Icons[selectedOption?.toLowerCase()]}
        </span>
        <span className="select-btn_text">
          {
            options.find((option) => {
              const isString = verfiyType(option, 'string');
              if (isString) {
                option.match(selectedOption) ||
                  option.match(selectedOption.toLowerCase());
              }
              return (
                option.value.match(selectedOption) ||
                option.value.match(selectedOption.toLowerCase())
              );
            })?.label
          }
        </span>
        <span className="select-btn_icon">
          <i className={`fas fa-chevron-${isContextOpen ? 'up' : 'down'}`} />
        </span>
      </button>
      {isContextOpen && (
        <ul className="select-options">
          <h6 className="select-title sdp-fc--blue-darker my-3">
            Change block to...
          </h6>
          {options?.map((option) => {
            const isString = verfiyType(option, 'string');
            const optionName = isString ? option : option.label;
            return (
              <li className="select-options_items" key={optionName}>
                <button
                  className="selector-options_items-btn"
                  type="button"
                  onClick={() => handleSelectItem(option)}
                >
                  <div className="select-options_items-icon">
                    {Icons[option.value.toLowerCase()]}
                  </div>
                  <div className="select-options_item-label">{optionName}</div>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

Select.propTypes = {
  options: [],
  selectedOption: string,
  onSelect: func
};

Select.defaultProps = {
  options: [],
  selectedOption: '',
  onSelect: func
};
